// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".focus {\n  -webkit-box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n          box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n  border-color: #a4cafe;\n}\n.invalid {\n  --border-opacity: 1;\n  border-color: #f8b4b4;\n  border-color: rgba(248, 180, 180, var(--border-opacity));\n  --text-opacity: 1;\n  color: #771d1d;\n  color: rgba(119, 29, 29, var(--text-opacity));\n}", ""]);
// Exports
module.exports = exports;
